const description = 'predictions.rules.desc' as const;

const generalRules = [
  'fantasy.rules.general_rule.0',
  'fantasy.rules.general_rule.1',
  'predictions.rules.general_rule.2',
  'fantasy.rules.general_rule.3',
  'fantasy.rules.general_rule.5',
] as const;

const prizeDistributionRules = [
  'fantasy.rules.prize_distribution.0',
  'fantasy.rules.prize_distribution.1',
  'fantasy.rules.prize_distribution.2',
  'fantasy.rules.prize_distribution.3',
  'fantasy.rules.prize_distribution.4',
  'fantasy.rules.prize_distribution.5',
] as const;

const scoreUpdateAndCompetitionClosingRules = [
  'fantasy.rules.score_update_and_competition_closing.0',
  'fantasy.rules.score_update_and_competition_closing.1',
] as const;

const rankingAndPointsCalcRule = 'fantasy.rules.ranking_and_points_calculations' as const;

const scoringSystem = {
  positive: {
    heading: 'fantasy.rules.positive',
    rules: [
      {
        rule: 'predictions.rules.correct_winner',
        points: 3,
      },
      {
        rule: 'predictions.rules.exact_score',
        points: 7,
      },
    ],
  },
  negative: null,
} as const;

export const predictionsRules = {
  description,
  sections: [
    {
      heading: 'fantasy.rules.general_rules',
      rules: generalRules,
    },
    {heading: 'fantasy.rules.prize_distribution', rules: prizeDistributionRules},
    {
      heading: 'fantasy.rules.score_update_and_competition_closing_heading',
      rules: scoreUpdateAndCompetitionClosingRules,
    },
    {
      heading: 'fantasy.rules.ranking_and_points_calc',
      rules: rankingAndPointsCalcRule,
    },
  ],
  scoringSystem: {
    heading: 'fantasy.rules.scoring_system',
    scoring: scoringSystem,
  },
} as const;
